export default __webpack_public_path__ + "static/media/hht2_Intonation_14.c99d5abf.png";